import { render, staticRenderFns } from "./InvoicePdfForm.vue?vue&type=template&id=47ad9a89&"
import script from "./InvoicePdfForm.vue?vue&type=script&lang=js&"
export * from "./InvoicePdfForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePdfForm.vue?vue&type=style&index=0&id=47ad9a89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports